import { useCallback } from 'react';
import { useState, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { EditorProvider } from './EditorContext';
//import Control from './FieldEditor/FieldEditor';
//import ControlForm from './FieldEditor/ControlForm';
//import VerticalLayout from './LayoutEditor/VerticalLayOut';
//import HorizontalLayout from './LayoutEditor/HorizontalLayout';
//import Label from './LayoutEditor/Label';

import Group from './GroupEditor/GroupEditor';
import { useSchemaGeneration } from '../hooks/useSchemaGeneration';
import { useFormStructure } from '../hooks/useFormStructure';
import { generateUniqueFieldName, validateFieldName } from '../utils/fieldNameGenerator';
import { controlFieldMap, getConditions, mapConditionsFields } from '../utils/formConditions';

//import { Popover } from 'bootstrap/dist/js/bootstrap.min.js';


function Field ({field, removeField}) {
  return (
    <>
      <p>{field.name}</p>
      <button
        className=""
        onClick={() => removeField(field.id)}
      >
        ❌
      </button>
    </>                          
  )
}


function EditorTab ({schema, data, uiSchema, setData,  setSchemas, setIsDirty}) {

  //console.log('schema: ', schema)
  //console.log('uiSchema: ', uiSchema)
  //console.log('data: ', data)
  
  // Доступные типы полей 
  // const fieldTypes = [
  //   { value: 'string', label: 'Текст', icon: '📝' },
  //   { value: 'number', label: 'Число', icon: '' },
  //   { value: 'integer', label: 'Целое число', icon: '' },
  // ];

  // // доступные макеты
  // const layoutTypes = [
  //   { value: 'Group', label: 'Группа полей', icon: '' },
  //   { value: 'VerticalLayout', label: 'Вертикальный макет', icon: '⬇' },
  //   { value: 'HorizontalLayout', label: 'Горизонтальный макет', icon: '' },

  // ];

  //const [fields, setFields] = useState([]);

  const [formStructure, setFormStructure] = useState({})
  const [editingElement, setEditingElement] = useState()
  
  // function findUiElementByScope(uiSchema, targetScope) {
  //   if (!uiSchema) {
  //     return undefined;
  //   }

  //   // Если текущий элемент - Control и scope совпадает, возвращаем его
  //   if (uiSchema.type === 'Control' && uiSchema.scope === targetScope) {
  //     return uiSchema;
  //   }

  //   // Если есть элементы (например, в Layout или Group), рекурсивно ищем в них
  //   if (Array.isArray(uiSchema.elements)) {
  //     for (let element of uiSchema.elements) {
  //       const found = findUiElementByScope(element, targetScope);
  //       if (found) {
  //         return found;
  //       }
  //     }
  //   }

  //   return undefined;
  // }  


  ////////////////////    Функции для создания структуры формы из schema и uiSchema выведены в React Custom hook     /////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const easStaticRowsRef = useRef([])
  // Пока открыт редактор, условия ссылаются на поля по id элемента: так переименование
  // и удаление поля не путают условия, даже если имя временно совпало с другим полем.
  const conditionsRef = useRef(getConditions({}))


  const { createFormStructure } = useFormStructure()


  if (Object.keys(uiSchema).length !== 0 ) {
    if (Object.keys(formStructure).length === 0 ) {
      const initialFormStructure = createFormStructure(uiSchema, schema, data)
      setFormStructure(initialFormStructure)

      easStaticRowsRef.current = schema.eas_static_rows ? schema.eas_static_rows : []
      conditionsRef.current = mapConditionsFields(getConditions(schema), controlFieldMap(initialFormStructure, 'name', 'id'))
    }
  }



  ////////////////////          Функции для редактирования структуры формы                /////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////

  function getGroupIndex(groupId) {
    for (let i in formStructure.elements) {
      if (formStructure.elements[i].id === groupId) {
        return Number(i) 
      }
    }
    return undefined;
  }

  function getLayoutOrLabelIndex(groupIndex, layoutOrLabelId) {

    for (let i in formStructure.elements[groupIndex].elements) {
      if (formStructure.elements[groupIndex].elements[i].id === layoutOrLabelId) {
        return Number(i) 
      }
    }
    return undefined;
  }

  function getFieldIndex(groupId, layoutId, fieldId) {
    return 0;
  }


  function createGroup(formStructure, upperGroupId, label){

    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));
    const groupLabel = label ? label : 'Новая группа макетов';
    const newGroup = { 
      id: uuidv4(),
      type: 'Group', 
      label: groupLabel,
      elements: []
    }

    const index = upperGroupId ? getGroupIndex(upperGroupId) + Number(1) : 0
    newFormStructure.elements.splice(index, 0, newGroup)

    setEditingElement(newGroup.id)
    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)
  }

  function updateGroup(formStructure, groupId, name){

    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));
    const index = getGroupIndex(groupId)
    newFormStructure.elements[index].label = name

    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)
  }


  function createLayout(formStructure, groupId, upperElementId, layoutType){
    
    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));
    const newLayout = { 
      id: uuidv4(),
      type: layoutType ? layoutType : 'HorizontalLayout',
      elements: []
    }

    const groupIndex = groupId ? getGroupIndex(groupId) : 0
    const layoutIndex = upperElementId ? getLayoutOrLabelIndex(groupIndex, upperElementId) + Number(1) : 0
    newFormStructure.elements[groupIndex].elements.splice(layoutIndex, 0, newLayout)

    setEditingElement(undefined)
    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)
  }


  function copyLayout (formStructure, groupId, layoutId) {

    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));

    const groupIndex = groupId ? getGroupIndex(groupId) : 0;
    const layoutIndex = layoutId ? getLayoutOrLabelIndex(groupIndex, layoutId) : 0;
    let layoutToCopy = newFormStructure.elements[groupIndex].elements[layoutIndex];
    
    let copiedLayout = JSON.parse(JSON.stringify(layoutToCopy))
    copiedLayout.id = uuidv4();

    for (let i in copiedLayout.elements) {
      copiedLayout.elements[i].id = uuidv4();
      if (copiedLayout.elements[i].type === 'Control') {
        copiedLayout.elements[i].scope = copiedLayout.elements[i].scope + '_copy'
      }
    }

    newFormStructure.elements[groupIndex].elements.splice(layoutIndex + 1, 0, copiedLayout);

    setEditingElement(undefined);
    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure);
  }


  function createLabel(formStructure, parentId, upperElementId){
    
    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));
    const newLabel = { 
      id: uuidv4(),
      type: 'Label',
      text: '...',
      options: {}
    }

    let path = findElementPath(formStructure, parentId)
    

    // Если глубина пути 4, значит лейбл находится внутри Group. Если глубина - 6, лейбл находится внутри Layout
    if (path.length === 2) {
      let groupId = parentId
      const groupIndex = groupId ? getGroupIndex(groupId) : 0
      const labelIndex = upperElementId ? getLayoutOrLabelIndex(groupIndex, upperElementId) + Number(1) : 0
      newLabel.options['labelRenderer'] = 'external'
      newFormStructure.elements[groupIndex].elements.splice(labelIndex, 0, newLabel)
    }
    if (path.length === 4) {
      let layoutId = parentId
      let groupId = newFormStructure.elements[path[1]].id

      const groupIndex = groupId ? getGroupIndex(groupId) : 0
      const layoutIndex = layoutId ? getLayoutOrLabelIndex(groupIndex, layoutId) : 0
      const labelIndex = upperElementId ? getFieldIndex(groupIndex, layoutIndex, upperElementId) + Number(1) 
      : newFormStructure.elements[groupIndex].elements[layoutIndex].elements.length
      newLabel.options['labelRenderer'] = 'standart'    
      newFormStructure.elements[groupIndex].elements[layoutIndex].elements.splice(labelIndex, 0, newLabel)
    }

    setEditingElement(newLabel.id)
    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)
  }

  function updateLabel(formStructure, labelId, property){

    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));
    let path = findElementPath(formStructure, labelId)
    
    //console.log(path)
    //alert (path.length)

    console.log(property) 
    //alert()

    let newLabel

    // Если глубина пути 4, значит лейбл находится внутри Group. Если глубина - 6, лейбл находится внутри Layout
    if (path.length === 4) {
      newLabel = JSON.parse(JSON.stringify(formStructure.elements[path[1]].elements[path[3]]))
    }
    if (path.length === 6) {
      newLabel = JSON.parse(JSON.stringify(formStructure.elements[path[1]].elements[path[3]].elements[path[5]]))
    } 


    if (property.id.startsWith('OPTIONS__')) {
      newLabel.options = newLabel.options ? newLabel.options : {}
      if (property.type === 'checkbox') {
        if (property.checked) {
          newLabel.options[property.id.split('__').pop()] = property.value
        } else {
          newLabel.options[property.id.split('__').pop()] = undefined
        }
      } else {
        newLabel.options[property.id.split('__').pop()] = property.value
      }
    } else {
      newLabel[property.id] = property.value
    }
    

    // Если глубина пути 4, значит лейбл находится внутри Group. Если глубина - 6, лейбл находится внутри Layout
    if (path.length === 4) {
      newFormStructure.elements[path[1]].elements[path[3]] = newLabel   
    }
    if (path.length === 6) {
      newFormStructure.elements[path[1]].elements[path[3]].elements[path[5]] = newLabel   
    }
    
    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)
  }


  function moveElement (formStructure, groupId, elementId, direction) {

    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));

    const groupIndex = groupId ? getGroupIndex(groupId) : 0
    const elementIndex = elementId ? getLayoutOrLabelIndex(groupIndex, elementId) : 0
    let movingElement = newFormStructure.elements[groupIndex].elements[elementIndex]

    if (direction === 'up') {
      if (elementIndex === 0) {
        return
      }
      newFormStructure.elements[groupIndex].elements.splice(elementIndex, 1)
      newFormStructure.elements[groupIndex].elements.splice(elementIndex - 1, 0, movingElement)
    }

    if (direction === 'down') {
      newFormStructure.elements[groupIndex].elements.splice(elementIndex, 1)
      newFormStructure.elements[groupIndex].elements.splice(elementIndex + 1, 0, movingElement)
    }

    setEditingElement(undefined)
    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)
  }


  function createField(formStructure, groupId, layoutId, upperFieldId, fieldType){
    
    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));
    
    // Генерируем уникальное имя для нового поля
    const fieldName = generateUniqueFieldName(schema);
    
    const newField = { 
      id: uuidv4(),
      type: "Control",
      scope: "#/properties/" + fieldName,
      label: false,
      options: {},
      schemaProps: {
        "type": fieldType || "integer",
        "title": fieldName,
        "maximum": 99,
        "filled": "lab",
        "ais_upload": false,
        "export_rows": [
          {
            "prop_analyte": "",
            "prop_kv": "",
            "prop_sample": "",
            "prop_measure": "",

          }
        ]
      },
    }

    const groupIndex = groupId ? getGroupIndex(groupId) : 0
    const layoutIndex = layoutId ? getLayoutOrLabelIndex(groupIndex, layoutId) : 0
    const fieldIndex = upperFieldId ? getFieldIndex(groupIndex, layoutIndex, upperFieldId) + Number(1) 
    : newFormStructure.elements[groupIndex].elements[layoutIndex].elements.length
    
    newFormStructure.elements[groupIndex].elements[layoutIndex].elements.splice(fieldIndex, 0, newField)

    setEditingElement(newField.id)
    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)
  }

  function changeFieldType(formStructure, controlId, fieldType) {

    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));
    let path = findElementPath(formStructure, controlId)
    let oldField = JSON.parse(JSON.stringify(formStructure.elements[path[1]].elements[path[3]].elements[path[5]]))
    
    //console.log(oldField)

    let newField = {}
    newField.options = {}
    newField.schemaProps = {}
    newField.id = oldField.id
    newField.type = oldField.type  // Это тип записи в UISchema - Control, Label, e.t.c.
    newField.scope = oldField.scope
    //newField.schemaProps.prop_analyte = oldField.schemaProps.prop_analyte
    //newField.schemaProps.prop_kv = oldField.schemaProps.prop_kv
    //newField.schemaProps.prop_section = oldField.schemaProps.prop_section
    //newField.schemaProps.prop_measure = oldField.schemaProps.prop_measure
    newField.schemaProps.filled = oldField.schemaProps.filled || 'lab'
    newField.schemaProps.ais_upload = oldField.schemaProps.ais_upload
    newField.schemaProps.export_rows = JSON.parse(JSON.stringify(oldField.schemaProps.export_rows))

    newField.schemaProps.type = fieldType // Это тип поля в Schema - Integer, Number, String, e.t.c.

    //console.log(newField)
    //alert(newField.schemaProps.type)

    // enum - это частный случай string
    if (newField.schemaProps.type === 'enum') {
      newField.schemaProps.type = 'string'
      newField.schemaProps.enum = ['', '']
    }

    if (newField.schemaProps.type === 'date') {
      newField.schemaProps.type = 'string'
      newField.schemaProps.format = 'date'
      newField.options.dateFormat = 'DD-MM-YYYY'
    }

    newFormStructure.elements[path[1]].elements[path[3]].elements[path[5]] = newField

    //console.log(newFormStructure)

    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)

  }

  function updateFieldUiSchema(formStructure, controlId, property){

    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));
    let path = findElementPath(formStructure, controlId)
    let newField = JSON.parse(JSON.stringify(formStructure.elements[path[1]].elements[path[3]].elements[path[5]]))


    if (property.id.startsWith('OPTIONS__')) {
      newField.options = newField.options ? newField.options : {}
      if (property.type === 'checkbox') {
        if (property.checked) {
          newField.options[property.id.split('__').pop()] = property.value
        } else {
          newField.options[property.id.split('__').pop()] = undefined
        }
      } else {
        newField.options[property.id.split('__').pop()] = property.value
      }
    } else {
      newField[property.id] = property.value
    }


    if (property.id === 'scope') {

      const fieldNameValidation = validateFieldName(property.value);
      if (!fieldNameValidation.isValid) {
        alert(`Ошибка в имени поля: ${fieldNameValidation.errors.join(', ')}`);
        return;
      }
      
      // Проверяем уникальность имени поля
      
      //const existingFieldNames = Object.keys(schema.properties || {});
      //const currentFieldName = newField.schemaProps.title;
      //const otherFieldNames = existingFieldNames.filter(name => name !== currentFieldName);
      
      //if (otherFieldNames.includes(property.value)) {
      //  alert(`Поле с именем "${property.value}" уже существует. Пожалуйста, выберите другое имя.`);
      //  return;
      //}
          
      //property.value = `#/properties/${property.value}`;
      newField.scope =`#/properties/${property.value}`;  
    }

    /*field = { 
      id: controlId,
      type: "Control",
      scope: "#/properties/" + props.name,
      label: false,
      options: {},
      schemaProps: {
        "type": "integer",
        "title": "код метода",
        "maximum": 99,
        "prop_analyte": props.prop_analyte,
        "prop_measure": "",
        "prop_kv": props.kv
      },*/

    newFormStructure.elements[path[1]].elements[path[3]].elements[path[5]] = newField

    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)
  }

  function updateFieldSchema(formStructure, controlId, property){

    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));
    let path = findElementPath(formStructure, controlId)
    let newField = JSON.parse(JSON.stringify(formStructure.elements[path[1]].elements[path[3]].elements[path[5]]))


    //console.log(property)
    //alert(property)
    /*field = { 
      id: controlId,
      type: "Control",
      scope: "#/properties/" + props.name,
      label: false,
      options: {},
      schemaProps: {
        "type": "integer",
        "title": "код метода",
        "maximum": 99,
        "prop_analyte": props.prop_analyte,
        "prop_measure": "",
        "prop_kv": props.kv
      },*/

    if (property.type === 'number') {
      if (property.value === '') {
        newField.schemaProps[property.id] = undefined  
      } else {
        newField.schemaProps[property.id] = Number(property.value)
      }
    } else {
      newField.schemaProps[property.id] = property.value
    }

    newFormStructure.elements[path[1]].elements[path[3]].elements[path[5]] = newField

    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)
  }


  // function findElementPathOld(structure, id) {
  //   //console.log(structure)
  //   if (!structure) return;
  //   if (structure.id === id) {
  //     //console.log(structure)
  //     return structure
  //   }
  //   // Если есть вложенные элементы (например, в Layout или Group), рекурсивно обрабатываем их
  //   if (Array.isArray(structure.elements)) {
  //     for (let element of structure.elements) {
  //       findElementPath(element, id);
  //     }
  //   }
  // }

  /**
   * Находит полный путь до элемента по ID
   * @param {Object} structure - структура формы
   * @param {string} targetId - ID искомого элемента
   * @returns {Array} массив индексов для доступа к элементу
   */
  function findElementPath(structure, targetId) {
    if (!structure || !targetId) return null;
    
    // Рекурсивная функция для поиска
    function searchPath(currentStructure, currentPath = []) {
      // Если это массив элементов
      if (Array.isArray(currentStructure.elements)) {
        for (let i = 0; i < currentStructure.elements.length; i++) {
          const element = currentStructure.elements[i];
          
          // Если нашли элемент
          if (element.id === targetId) {
            return [...currentPath, 'elements', i];
          }
          
          // Рекурсивно ищем в подэлементах
          const result = searchPath(element, [...currentPath, 'elements', i]);
          if (result) {
            return result;
          }
        }
      }
      
      return null;
    }
    
    return searchPath(structure);
  }


  const removeElement = (formStructure, id) => {
    console.log('removeElement called with:', { 
      formStructure: formStructure ? 'exists' : 'undefined', 
      id: id,
      formStructureType: typeof formStructure,
      idType: typeof id
    });
    

    function removeElementById(structure, targetId) {
      if (!structure) return false;

      // Проверяем, есть ли у текущего элемента вложенные элементы
      if (Array.isArray(structure.elements)) {
        for (let i = 0; i < structure.elements.length; i++) {
          const element = structure.elements[i];
          if (element.id === targetId) {
            // Удаляем элемент из массива
            structure.elements.splice(i, 1);
            return true;
          } else {
            // Рекурсивно ищем в поддереве
            if (removeElementById(element, targetId)) {
              return true;
            }
          }
        }
      }

      return false;
    }

    const newFormStructure =  JSON.parse(JSON.stringify(formStructure));

    removeElementById(newFormStructure, id)
    setFormStructure(newFormStructure);
    updateSchemaAndUiSchema(newFormStructure)

  };



  //////////////    Функции для генерации schema и uiSchema из formStructure выведены в React Custom hook   ////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  const { generateNewSchemas } = useSchemaGeneration()
  

  const updateSchemaAndUiSchema = useCallback((formStructure) => {

    setIsDirty(true)

    const conditions = mapConditionsFields(conditionsRef.current, controlFieldMap(formStructure, 'id', 'name'))
    const {newSchema, newData, newUiSchema} = generateNewSchemas(formStructure, easStaticRowsRef.current, conditions)
    
    setSchemas(newSchema, newUiSchema);
    setData(newData);

  }, [generateNewSchemas, setIsDirty, setData, setSchemas])



  //////////////                           рендеринг formStructure                            ////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////

   const editorActions = {
    editingElement,
    setEditingElement,
    findElementPath,

    createGroup,
    updateGroup,
    createLayout,
    copyLayout,
    createLabel,
    updateLabel,
    moveElement,
    createField,
    changeFieldType,
    updateFieldUiSchema,
    updateFieldSchema,
    removeElement,

    updateSchemaAndUiSchema,

  };
 


  let rows = [];
  for(let i in formStructure.elements) {
    if (formStructure.elements[i].type === 'Group') {
      //console.log('group selected!')
      //console.log(formStructure.elements[i])
      rows.push(
        <div key={formStructure.elements[i].id}>
          <Group
            group={formStructure.elements[i]}
            formStructure={formStructure}
            //removeElement={removeElement}
            //createLayout={createLayout}
            //createField={createField}
          />
          <div>
            <button
              className="btn lk-button"
              onClick={() => createGroup(formStructure, formStructure.elements[i].id)}
            > 
              создать группу
            </button>
          </div>
        </div>
      );
    }  
  }

  console.log('Editor Tab rendering')
  console.log(formStructure)

  
  //useEffect(() => {
  //  Array.from(document.querySelectorAll('button[data-bs-toggle="popover"]'))
  //    .forEach(popoverNode => new Popover(popoverNode))
  //})


  return (
    <EditorProvider {...editorActions}>
      <div className='mt-5 ps-0'>
        <button
          className="btn lk-button"
          onClick={() => createGroup(formStructure, 2)}
        >
          создать группу
        </button>
        {rows}
      </div>
    </EditorProvider>
  )
}

export default EditorTab

